// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 768px) {
  .my-dashboard_dashboard-left__2wG6n {
    display: grid;
    align-items: center;
    justify-content: center;
  }

  .my-dashboard_submission__XBQqQ {
    display: flex;
    justify-content: center;
  }

  .my-dashboard_wrapper__GFxBI {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }

  .my-dashboard_content__Pa55q {
    width: fit-content;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/my-dashboard.module.css"],"names":[],"mappings":"AAAA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["@media (max-width: 768px) {\n  .dashboard-left {\n    display: grid;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .submission {\n    display: flex;\n    justify-content: center;\n  }\n\n  .wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 24px;\n  }\n\n  .content {\n    width: fit-content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard-left": `my-dashboard_dashboard-left__2wG6n`,
	"submission": `my-dashboard_submission__XBQqQ`,
	"wrapper": `my-dashboard_wrapper__GFxBI`,
	"content": `my-dashboard_content__Pa55q`
};
export default ___CSS_LOADER_EXPORT___;
